export default __webpack_public_path__ + "static/media/Mark-4-HUD-04.6d1500bc.jpg";